import { useQuery } from 'react-query';
import { archivosFetch } from '../../utils/fetch';
import { AuthUser } from '../../models/user';
import { Service } from '../../models/service';
import { AdminEntity } from '../../models/adminEntity';
import { HOME_SERVICES_KEY, HOME_USERS_KEY } from '../Home/useFilterOptions';

// The lists that feed the user form: services (chips
// "Service"), users ("Pour le compte de") and functions (suggestions for the
// "Fonction" field).
//
// Services and users share a cache key with the Home: they are the same
// calls and the same JSON. Functions: `GET /api/functions/` is the entity
// administrable at /functions; only the active ones are offered. The XD draws
// "Fonction" as free text ("Saisissez votre fonction") and the model
// stores it as a string, so the list is suggestions, not a restriction. The
// functions typed on accounts are added to them by the form (index.tsx).

export const FUNCTIONS_KEY = 'USER_FORM_FUNCTIONS';

const fetchCollection = async <T>(path: string, key: string): Promise<T[]> => {
  const response = await archivosFetch(
    `${process.env.REACT_APP_API_URL}/api/${path}/`,
  );
  if (!response.ok) return [];

  const body = await response.json();
  return Array.isArray(body?.[key]) ? body[key] : [];
};

export const useUserFormOptions = (enabled: boolean) => {
  const options = { enabled, staleTime: 5 * 60 * 1000, retry: false };

  const services = useQuery<Service[]>(
    [HOME_SERVICES_KEY],
    () => fetchCollection<Service>('services', 'services'),
    options,
  );
  const users = useQuery<AuthUser[]>(
    [HOME_USERS_KEY],
    () => fetchCollection<AuthUser>('users', 'users'),
    options,
  );
  const functions = useQuery<AdminEntity[]>(
    [FUNCTIONS_KEY],
    () => fetchCollection<AdminEntity>('functions', 'functions'),
    options,
  );

  return {
    services: services.data ?? [],
    users: users.data ?? [],
    functions: (functions.data ?? []).filter((entity) => entity.active),
  };
};
